import React from 'react';

const Hero = () => (
  <header className="bg-primary text-gray-800 relative overflow-hidden">
    <div className="absolute inset-0 bg-[url()] opacity-10 animate-pulse"></div>
    <div className="container mx-auto px-4 py-24 relative">
      <div className="animate-slideUp">
        <h1 className="text-6xl font-bold mb-6">Lakjaya Cargo Service</h1>
        <p className="text-2xl mb-8 opacity-90">Delivering Excellence Across Borders</p>
        <button className="bg-white px-8 py-3 rounded-lg font-medium hover:bg-gray-100 
                         transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg">
          Get Started
        </button>
      </div>
    </div>
  </header>
);

export default Hero;
